import { z } from 'zod'
import { pageCursorSchema } from '../helpers/page-cursor.js'
import { webhookDeliveryStatusSchema } from '../enums/webhook-delivery-status.enum.js'
import { envelopeWebhookEventNameSchema, webhookEventNameSchema } from '../enums/webhook-event.enum.js'
import { uuidSchema } from '../validators/params.js'

/** Filters for the webhook log. */
export const webhookDeliveryQuerySchema = z
  .object({
    envelopeId: uuidSchema.optional(),
    event: webhookEventNameSchema.optional(),
    status: webhookDeliveryStatusSchema.optional(),
    /** A previous page's `nextBefore`. */
    before: pageCursorSchema.optional(),
  })
  .strict()

export type WebhookDeliveryQuery = z.infer<typeof webhookDeliveryQuerySchema>

/** Send a synthetic event of this type to the test webhook URL (test mode only). */
/** Test events are envelope events: billing events are never synthesized. */
export const sendTestEventInputSchema = z.object({ event: envelopeWebhookEventNameSchema }).strict()

export type SendTestEventInput = z.infer<typeof sendTestEventInputSchema>
